// SBTableRow.tsx
import { TableRow, styled } from '@mui/material';

const SBTableRow = styled(TableRow)(() => ({
  borderBottom: '1px solid var(--mui-palette-border-tableRow)',
  transition: 'all 0.2s ease-in-out',
  cursor: 'pointer',
  position: 'relative',

  '& > td:first-of-type > div': {
    borderLeft: 0,
  },

  '&.selected': {
    background: 'var(--mui-palette-primary-light)',
    boxShadow: 'inset 4px 0 0 0 var(--mui-palette-primary-main)',
  },

  '&:hover': {
    background: 'var(--mui-palette-primary-light)',
    transform: 'translateX(4px)',
  },

  '&:active': {
    transform: 'translateX(4px) scale(0.995)',
  },

  '&.selected:hover': {
    background: 'var(--mui-palette-primary-light)',
  },

  '&::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '4px',
    background: 'transparent',
    transition: 'background 0.2s ease',
  },

  '&:hover::after': {
    background: 'var(--mui-palette-primary-main)',
  },

  '@media (prefers-reduced-motion: reduce)': {
    transition: 'none',
    '&:hover': {
      transform: 'none',
    },
  },
}));

export { SBTableRow };
